'use strict';

var React = require('react');

var SvgStoreManagedIcon = function SvgStoreManagedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.278 3a2.75 2.75 0 0 1 2.162 1.051l2.087 2.656c.073.093.136.193.19.298l.079.159c.707 1.414.02 3.03-1.296 3.612v1.599a.75.75 0 0 1-1.5 0v-1.41a2.651 2.651 0 0 1-1.705-1.037 2.99 2.99 0 0 1-4.59 0 2.651 2.651 0 0 1-1.705 1.038v4.284c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5a1.75 1.75 0 0 1-1.75-1.75v-4.474c-1.317-.583-2.003-2.198-1.295-3.612l.079-.159a1.75 1.75 0 0 1 .189-.298l2.087-2.656a2.75 2.75 0 0 1 2.162-1.051h4.556Zm-3.926 4.802a.747.747 0 0 0-.855-.258.747.747 0 0 0-.418.37l-.474.95a1.15 1.15 0 1 1-2.059-1.03l.08-.158a.25.25 0 0 1 .026-.042l2.087-2.656c.237-.302.6-.478.983-.478h4.556c.383 0 .746.176.983.478l2.087 2.656c.01.013.019.027.027.042l.079.159a1.15 1.15 0 0 1-2.059 1.029l-.474-.95a.746.746 0 0 0-1.006-.335.747.747 0 0 0-.394.496l-.074.295a1.491 1.491 0 0 1-2.894 0l-.074-.295a.75.75 0 0 0-.127-.273Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78 14.28a.75.75 0 1 0-1.06-1.06l-2.97 2.97-1.22-1.22a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l3.5-3.5Z"
  }));
};
SvgStoreManagedIcon.displayName = "StoreManagedIcon";

exports.SvgStoreManagedIcon = SvgStoreManagedIcon;
